export function isMatchingPath(pathname) {
    return /^\/(ext)?matching\/?$/.test(pathname)
}

export function isDematchingPath(pathname) {
    return /^\/(ext)?dematching\/?$/.test(pathname)
}

export function isMatchingSectionPath(pathname) {
    return isMatchingPath(pathname) || isDematchingPath(pathname)
}

export function isPriceManagementPath(pathname) {
    return pathname.startsWith("/pricemanagement")
}
